import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

import {
  BaseExceptions,
  getMessageFromErrorResponse,
  isBaseError,
} from '@/api/v4/base-fetch';
import { requestProject } from '@/api/v4/request-project.api';
import { notify } from '@/ui/snackbar/notify';

export const useRequestProject = () => {
  const { t } = useTranslation('default');

  const requestProjectMutation = useMutation({
    mutationFn: async (data: Parameters<typeof requestProject>[0]) => {
      return requestProject(data);
    },
    onError: (error: unknown) => {
      if (isBaseError(error)) {
        if (error.response.status === BaseExceptions.BAD_REQUEST) {
          const message = getMessageFromErrorResponse(error);
          notify({ message: message ?? t`unknownError` });
          return;
        }
      }
      notify({ message: t`unknownError` });
    },
  });

  return {
    submitRequest: requestProjectMutation.mutateAsync,
    isLoading: requestProjectMutation.isPending,
    isSuccess: requestProjectMutation.isSuccess,
    isError: requestProjectMutation.isError,
    error: requestProjectMutation.error,
  };
};
